<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <text x="5" y="18" font-family="sans-serif" font-size="16" font-weight="bold" fill="white">£</text>
  <path d="M18 8L18 20" stroke="white" stroke-width="1.8" stroke-linecap="round"/>
  <path d="M18 20L14 16" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M18 20L22 16" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
